import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/intercom-icon.svg'
import _imports_1 from '@/assets/img/checkbox-on.svg'


const _hoisted_1 = { class: "header-auth-n-currency flex middle-xs" }
const _hoisted_2 = {
  key: 0,
  class: "b-currency-lang flex middle-xs"
}
const _hoisted_3 = { class: "medium black" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "black" }
const _hoisted_6 = { class: "grey" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "black" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  width: "14",
  height: "16",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "medium" }
const _hoisted_15 = { class: "lang-n-currency__modal_content" }
const _hoisted_16 = { class: "lang-n-currency__modal_content_langs" }
const _hoisted_17 = { class: "medium black" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex middle-xs" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "regular black" }
const _hoisted_22 = {
  key: 0,
  src: _imports_1,
  alt: ""
}
const _hoisted_23 = { class: "lang-n-currency__modal_content_currencies border-top" }
const _hoisted_24 = { class: "medium black" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "regular black" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = {
  key: 0,
  src: _imports_1,
  alt: ""
}

import { ref, watch, computed, ComputedRef } from 'vue';
  import { useStore } from 'vuex';
  import { RouterLink } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import debounce from 'lodash/debounce';
  import { lazyComponent } from '@/router/routes';
  import { Currency, Lang, User } from 'types';
  import Emitter, { EVENT_NAMES } from '@/plugins/emitter';
  import { intercom } from '@/plugins';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderAuthAndCurrencyComponent',
  props: {
    isMainPage: {
      type: Boolean,
      default: false,
    },
    isProfilePage: {
      type: Boolean,
      default: false,
    },
  },
  setup(__props) {

  

  const CustomDropdownComponent = lazyComponent('CustomDropdownComponent');
  const ButtonComponent = lazyComponent('ButtonComponent');
  const SpinnerComponent = lazyComponent('SpinnerComponent');
  const RightSidebarModalComponent = lazyComponent(
    'RightSidebarModalComponent',
  );

  const { t } = useI18n();
  const store = useStore();

  const userV2: ComputedRef<User.UserV2> = computed(
    () => store.state.user.userV2,
  );
  const authLoading: ComputedRef<boolean> = computed(
    () => store.state.user.loading,
  );
  const isAppView: ComputedRef<boolean> = computed(
    () => store.state.support.isAppView,
  );
  const isMobile: ComputedRef<boolean> = computed(
    () => store.state.support.isMobile,
  );
  const currency: ComputedRef<Currency.CurrencyItem> = computed(
    () => store.state.support.currency,
  );
  const lang: ComputedRef<Lang.LangItem> = computed(
    () => store.state.support.lang,
  );

  const isLangsOpen = ref<boolean>(false);
  const isCurrencyOpen = ref<boolean>(false);
  const isLangNCurrencyModalOpen = ref<boolean>(false);

  const debouncer = debounce(onLocaliztionChanged, 300);

  const locales = computed(() => {
    return Lang.langsList().filter(it => it.isAvailable);
  });

  const initials: ComputedRef<string> = computed(() => {
    if (userV2.value) {
      return userV2.value.firstName
        ? userV2.value.firstName.substring(0, 1)
        : userV2.value.email
        ? userV2.value.email.substring(0, 1)
        : '?';
    }
    return '';
  });

  watch(currency, () => {
    debouncer(EVENT_NAMES.CURRENCY_CHANGED);
  });

  watch(lang, () => {
    debouncer(EVENT_NAMES.LOCALE_CHANGED);
  });

  watch(isMobile, () => {
    store.dispatch('support/updateIntercomSettings', {});
  });

  function onLocaliztionChanged(event: EVENT_NAMES) {
    Emitter.$emit(event);
  }

  function showIntercom() {
    intercom.show();
  }

  function openDialog() {
    if (!authLoading.value && userV2.value === null) {
      store.commit('user/setRegisterDialogShown', true);
    }
  }

  function selectLang(langItem: Lang.LangItem) {
    if (lang.value.locale !== langItem.locale) {
      store.commit('support/setLang', langItem);
      store.dispatch('user/getUser');
    }

    isLangsOpen.value = false;
  }

  function selectCurrency(currencyItem: Currency.CurrencyItem) {
    if (currency.value.currency !== currencyItem.currency) {
      store.commit('support/setCurrency', currencyItem);
      store.dispatch('user/getUser');
    }
    isCurrencyOpen.value = false;
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(CustomDropdownComponent), {
            class: "b-currency-lang__curr",
            isOpen: isCurrencyOpen.value,
            onSetOpen: _cache[0] || (_cache[0] = ($event: any) => (isCurrencyOpen.value = $event))
          }, {
            options: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Currency).currenciesList(), (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: _normalizeClass(["flex middle-xs between-xs regular", { unavailable: !item.isAvailable }]),
                  role: "button",
                  onClick: ($event: any) => (selectCurrency(item))
                }, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.name), 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(item.currency), 1)
                ], 10, _hoisted_4))
              }), 128))
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(currency).currency), 1)
            ]),
            _: 1
          }, 8, ["isOpen"]),
          _createVNode(_unref(CustomDropdownComponent), {
            class: "b-currency-lang__lang",
            isOpen: isLangsOpen.value,
            onSetOpen: _cache[1] || (_cache[1] = ($event: any) => (isLangsOpen.value = $event))
          }, {
            options: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(locales), (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: _normalizeClass(["flex middle-xs between-xs regular", { unavailable: !item.isAvailable }]),
                  role: "button",
                  onClick: ($event: any) => (selectLang(item))
                }, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.lang), 1),
                  _createElementVNode("img", {
                    src: require(`@/assets/img/flags/${item.flagPath}`),
                    alt: ""
                  }, null, 8, _hoisted_10)
                ], 10, _hoisted_8))
              }), 128))
            ]),
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: require(`@/assets/img/flags/${_unref(lang).flagPath}`),
                alt: ""
              }, null, 8, _hoisted_7)
            ]),
            _: 1
          }, 8, ["isOpen"])
        ]))
      : _createCommentVNode("", true),
    (_unref(isMobile) && __props.isMainPage)
      ? (_openBlock(), _createBlock(_unref(ButtonComponent), {
          key: 1,
          class: _normalizeClass(["header-auth-n-currency_settings non-padding", { 'profile-settings': __props.isProfilePage }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (isLangNCurrencyModalOpen.value = true)),
          "aria-label": "Settings"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: require(`@/assets/img/flags/${_unref(lang).flagPath}`),
              alt: ""
            }, null, 8, _hoisted_11)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    _createVNode(_unref(ButtonComponent), {
      class: "b-intercom-btn non-padding no-shadow flex middle-xs center-xs",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (showIntercom())),
      id: "intercom-launcher"
    }, {
      default: _withCtx(() => [
        _hoisted_12
      ]),
      _: 1
    }),
    (!_unref(isAppView) && !__props.isProfilePage)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (!_unref(userV2) || _unref(authLoading))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (!_unref(isMobile))
                  ? (_openBlock(), _createBlock(_unref(ButtonComponent), {
                      key: 0,
                      class: "primary auth-btn",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (openDialog()))
                    }, {
                      default: _withCtx(() => [
                        (_unref(authLoading))
                          ? (_openBlock(), _createBlock(_unref(SpinnerComponent), {
                              key: 0,
                              width: 24
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(_unref(t)('signUp')), 1)
                            ], 64))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_unref(ButtonComponent), {
                      key: 1,
                      class: "sing-up-link flex middle-xs center-xs",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (openDialog()))
                    }, {
                      default: _withCtx(() => [
                        (_unref(authLoading))
                          ? (_openBlock(), _createBlock(_unref(SpinnerComponent), {
                              key: 0,
                              width: 24,
                              color: "white"
                            }))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: require(`@/assets/img/person-sing-up.svg`),
                              alt: ""
                            }, null, 8, _hoisted_13))
                      ]),
                      _: 1
                    }))
              ], 64))
            : (_openBlock(), _createBlock(_unref(RouterLink), {
                key: 1,
                class: "profile-link flex middle-xs center-xs",
                to: "/profile"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(initials)), 1)
                ]),
                _: 1
              }))
        ], 64))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_unref(RightSidebarModalComponent), {
          key: 3,
          state: isLangNCurrencyModalOpen.value,
          class: "lang-n-currency__modal start-xs",
          onSetState: _cache[7] || (_cache[7] = ($event: any) => (isLangNCurrencyModalOpen.value = $event)),
          "modal-name": "lang-n-currency"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)('selectLang')), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(locales), (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: i,
                      class: _normalizeClass(["flex middle-xs between-xs", { unavailable: !item.isAvailable }]),
                      role: "button",
                      onClick: ($event: any) => (selectLang(item))
                    }, [
                      _createElementVNode("span", _hoisted_19, [
                        _createElementVNode("img", {
                          src: require(`@/assets/img/flags/${item.flagPath}`),
                          alt: ""
                        }, null, 8, _hoisted_20),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(item.lang), 1)
                      ]),
                      (_unref(lang).lang === item.lang)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_22))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_18))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(t)('selectCurrency')), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(Currency).currenciesList(), (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: i,
                      class: _normalizeClass(["flex middle-xs between-xs", { unavailable: !item.isAvailable }]),
                      role: "button",
                      onClick: ($event: any) => (selectCurrency(item))
                    }, [
                      _createElementVNode("span", _hoisted_26, [
                        _createElementVNode("span", null, _toDisplayString(item.name), 1),
                        _hoisted_27,
                        _createElementVNode("span", null, _toDisplayString(item.currency), 1)
                      ]),
                      (_unref(currency).currency === item.currency)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_28))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_25))
                  }), 128))
                ])
              ])
            ]),
            _createVNode(_unref(ButtonComponent), {
              variant: "secondary",
              class: "no-shadow btn-done",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (isLangNCurrencyModalOpen.value = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('doneBtn')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["state"]))
      : _createCommentVNode("", true)
  ]))
}
}

})